<section class="main_section">
    <div class="header_section d-flex justify-content-between align-items-center">
        <div class="section_heading">
            Price Breakdown
        </div>
        <div class="close_btn" (click)="close()">
            <mat-icon class="cursor-pointer">close</mat-icon>
        </div>
    </div>
    <div class="body_section p-2">
        <div class="plan_name">{{pricebreakDownDetails?.planName | titlecase}}</div>
        <div class="body_main d-flex justify-content-between align-items-center">
            <div class="all_titles">
                <div class="single_title">
                    Actual Plan Amount
                </div>
                <div class="single_title">
                    Discount
                </div>
                <div class="single_title">
                    Processing Fee
                </div>
                <div class="single_title">
                    Tax Amount
                </div>
                <div class="grandTotal">
                    Payable Total
                </div>
            </div>
            <div class="all_values">
                <div class="single_value">
                    {{data.actualPlanAmount}}
                </div>
                <div class="single_value">
                    {{pricebreakDownDetails?.discountAmount}}
                </div>
                <div class="single_value">
                    {{pricebreakDownDetails?.processingFee}}&nbsp;({{pricebreakDownDetails?.processingFeePercent}})
                </div>
                <div class="single_value">
                    {{pricebreakDownDetails?.taxAmount}}&nbsp;({{pricebreakDownDetails?.taxPercent}})
                </div>
                <div class="total_amount">
                    {{pricebreakDownDetails?.totalAmount}}
                </div>
            </div>
        </div>
    </div>
    <div class="footer_section">
        <button (click)="continuePayment()">Continue</button>
    </div>
</section>